if (!customElements.get('gf-hero-carousel')) {
  customElements.define('gf-hero-carousel', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.slides = [...this.querySelectorAll('[data-slide]')];
      this.index = 0;
      // Fetch upcoming banner images before a user advances to a hidden slide.
      this.slides.slice(1).forEach(slide => {
        const image = slide.querySelector('img');
        if (image) { image.fetchPriority = 'low'; image.loading = 'eager'; }
      });
      this.motion = matchMedia('(prefers-reduced-motion: reduce)');
      this.paused = this.dataset.autoplay !== 'true' || this.motion.matches;
      this.focused = false;
      this.addEventListener('focusin', () => { this.focused = true; this.updateTimer(); }, options);
      this.addEventListener('focusout', () => queueMicrotask(() => {
        if (!this.isConnected) return;
        this.focused = this.contains(document.activeElement); this.updateTimer();
      }), options);
      this.addEventListener('keydown', (event) => {
        if (!['ArrowRight', 'ArrowLeft'].includes(event.key) || /INPUT|TEXTAREA|SELECT/.test(event.target.tagName)) return;
        event.preventDefault();
        const withinSlide = event.target.closest('[data-slide]');
        this.go(this.index + (event.key === 'ArrowRight' ? 1 : -1), true);
        if (withinSlide) this.slides[this.index].querySelector('a')?.focus();
      }, options);
      this.addEventListener('touchstart', event => {
        const touch = event.touches[0];
        this.touchStart = { x: touch.clientX, y: touch.clientY };
      }, { ...options, passive: true });
      this.addEventListener('touchend', event => {
        if (!this.touchStart) return;
        const touch = event.changedTouches[0];
        const dx = touch.clientX - this.touchStart.x;
        const dy = touch.clientY - this.touchStart.y;
        if (Math.abs(dx) > 55 && Math.abs(dx) > Math.abs(dy) * 1.5) this.go(this.index + (dx < 0 ? 1 : -1), true);
        this.touchStart = null;
      }, { ...options, passive: true });
      document.addEventListener('visibilitychange', () => this.updateTimer(), options);
      this.motion.addEventListener('change', () => { this.paused = this.dataset.autoplay !== 'true' || this.motion.matches; this.updateTimer(); }, options);
      document.addEventListener('shopify:block:select', event => {
        const i = this.slides.findIndex(slide => slide.dataset.blockId === event.detail.blockId);
        if (i >= 0) { this.paused = true; this.go(i, true); }
      }, options);
      this.updateTimer();
    }
    go(index, manual = false) {
      if (!this.slides.length) return;
      this.index = (index + this.slides.length) % this.slides.length;
      this.slides.forEach((slide, i) => { slide.hidden = i !== this.index; slide.inert = i !== this.index; });
      if (manual) {
        this.querySelector('[data-status]').textContent = `Slide ${this.index + 1} of ${this.slides.length}`;
      }
      this.updateTimer();
    }
    updateTimer() {
      clearTimeout(this.timer);
      if (!this.paused && !this.focused && !document.hidden && this.slides.length > 1) {
        this.timer = setTimeout(() => this.go(this.index + 1), Number(this.dataset.interval) || 6000);
      }
    }
    disconnectedCallback() {
      clearTimeout(this.timer);
      this.controller?.abort();
      this.controller = null;
    }
  });
}
